import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';
import { LangagesService } from '../../../../services/manage/langages/langages.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import {CssService} from "../../../../services/css-service";

@Component({
  selector: 'app-header-client',
  templateUrl: './header-client.component.html',
  styleUrls: ['./header-client.component.css']
})

export class HeaderClientComponent implements OnInit {

  @Input()
  opened: boolean|any;

  @Output()
  toggleMenu = new EventEmitter();

  url: string = this.router.url;

  languages: Object[] = [
    {
      url: "assets/img/countryflag/english.png",
      value: "en"
    },
    {
      url: "assets/img/countryflag/french.png",
      value: "fr"
    }
  ];
  domainUser:any;
  constructor(
    private authService: AuthService,
    private translate: LangagesService,
    public cssService: CssService,
    private router: Router,
    private tools: ToolsService
  ) { }

  ngOnInit() {
    this.domainUser=this.tools.getStor("domainUser")?this.tools.getStor("domainUser"):null;
  }

  toggleParent(): void {
    this.toggleMenu.emit();
  }

  chooseLanguage(lang: string): void {
    this.translate.setLang(lang);
  }

  logOut(): void {


    this.authService.logOut("/auth/home");
  }

}
